import { Role, RoleContext } from '../../setting/expert/expert.const';

const default_avt = 'assets/images/contact.png';
export const getDisplayGroupColumn = (data, groups) => {
  let res = '';
  const groupIds = data.groupId.split(',');

  for (let i = 0; i < groupIds.length; i++) {
    const group = groups.find(g => g.id == parseInt(groupIds[i]));
    if (i > 0) res += ',';
    res += groupIds[i] ? (group ? group.name : groupIds[i]) : '';
  }
  return res;
};
export const getDisplayNameColumn = (data, agents) => {
  const agent = agents.find(
    g => g.email === data.username || g.phone === data.username || g.agent_id === data.username
  );
  const displayName = agent ? (agent.name ? agent.name : '(Không xác định)') : '(Không xác định)';
  const avatars = data.avatar ? data.avatar : agent ? (agent.avatar ? agent.avatar : default_avt) : default_avt;
  return `<img class="img-circle avatar avatar-sm" src="${avatars}" alt="${displayName}"> ${displayName} - ${data.agentId}`;
};
export const getName = (data, agents) => {
  const agent = agents.find(
    g => g.email === data.username || g.phone === data.username || g.agent_id === data.username
  );
  return agent ? (agent.name ? agent.name : '') : '';
};
export const getDisplayUserNameColumn = (data, agents) => {
  const agent = agents.find(g => g.agent_id === data.agentId);
  return data.username
    ? data.username
    : agent
      ? agent.email
        ? agent.email
        : agent.phone
          ? agent.phone
          : agent.agent_id
            ? agent.agent_id
            : ''
      : '';
};
export const getDisplayRoleColumn = (data, user) => {
  if (data.agentId === user.agent_id) return `<small class="badge badge-default">Là bạn</small>`;
  switch (data.role) {
    case Role.Agent:
      return `<small class="badge badge-primary">` + RoleContext.Agent + `</small>`;
    case Role.Supervisor:
      return `<small class="badge badge-info">` + RoleContext.Supervisor + `</small>`;
    case Role.Administrator:
      return `<small class="badge badge-warning">` + RoleContext.Administrator + `</small>`;
    case Role.TeamLeader:
      return `<small class="badge badge-success">` + RoleContext.TeamLeader + `</small>`;
  }
};
export const getDisplayStatusColumn = data => {
  switch (data.status) {
    case 'ANSWERING':
      return `<small class="badge badge-success">Đang trả lời</small>`;
    case 'QUEUEING':
      return `<small class="badge badge-info">Trong hàng đợi</small>`;
    case 'RINGING':
      return `<small class="badge badge-primary">Đang đổ chuông</small>`;
    case 'MUTING':
      return `<small class="badge badge-default">Đang tắt mic</small>`;
    case 'HOLDING':
      return `<small class="badge badge-warning">Đang giữ máy</small>`;
    case 'DIALING':
      return `<small class="badge badge-warning">Đang kết nối</small>`;
  }
};
export const getDisplayTypeColumn = data => {
  switch (data.callType) {
    case 'CALL_INBOUND':
      return `<small class="badge badge-default" tooltip="${data.callId}">Gọi vào</small>`;
    case 'CALL_OUTBOUND':
      return `<small class="badge badge-info" tooltip="${data.callId}">Gọi ra</small>`;
    case 'CAMPAIGN':
      return `<small class="badge badge-primary" tooltip="${data.callId}">Gọi chiến dịch</small>`;
    case 'ZALO':
      return `<small class="badge badge-primary" tooltip="${data.callId}">Gọi zalo</small>`;
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/call-monitor/call-monitor.const.ts